$ = jQuery;

$( ".navbar-toggler-js" ).click(function() {
    $( this ).find('i').toggleClass('fa-xmark fa-bars');
});

$( ".navbar .navbar-nav li.dropdown a" ).click(function() {
    $( this ).toggleClass('custom-active-dropdown');
});

$(document).ready(function(){
    $(".owl-carousel").owlCarousel({
        loop:false,
        rewind: true,
        autoplay:true,
        autoplayTimeout:5000,
        nav:false,
        dots:false,
        items:4,
        margin:42,
        //responsiveClass:true,
        responsive:{
            0:{
                items:1,
            },
            600:{
                items:3,
            },
            1000:{
                items:4,
            }
        }
    });
});

$( function() {
    $( document ).tooltip();
});

// The content read more
$('#more-content').on('click', function() {
    $('#collapsevice').toggleClass('d-block');
    $('#more-content').text(function(v){
        text = $('#more-content').text();
        return text === 'Více' ? 'Méně' : 'Více';
     })
});

// The gallery load more
$(function() {
    $("#load-gallery").click(function(e) { 
      e.preventDefault();
      $(".gallery-item:hidden").slice(0, 3).show();
      var val = $(".gallery-count-items strong").text().replace(/\+/g, ''); 
      var val2 = parseInt(val) - 3;
      var final = '+' + val2;
      $(".gallery-count-items strong").text(final);
      if ($(".gallery-item:hidden").length == 0) { 
        $(".gallery-count").remove(); 
      }
    });
});

// Videos +8 etc.
$(function() {
    var h = $("#video").height();
    $(".video-count").css('height', h);
});

// The video load more
$(function() {
    $("#load-video").click(function(e) { 
      e.preventDefault();
      $(".video-item:hidden").slice(0, 3).show();
      var val = $(".video-count-items strong").text().replace(/\+/g, ''); 
      var val2 = parseInt(val) - 3;
      var final = '+' + val2;
      $(".video-count-items strong").text(final);
      if ($(".video-item:hidden").length == 0) { 
        $(".video-count").remove(); 
      }
    });
});

// Video +8 etc.
$(function() {
    var h = $("#video").height();
    $(".video-count").css('height', h);
});

$(".card-link.second").mouseover(function (e) {    
    $('.card-link.second #blog').attr("src", $('.card-link.second #blog').attr("src").replace("ostatni2", "ostatni"));
}).mouseout(function (e) {
    $('.card-link.second #blog').attr("src", $('.card-link.second #blog').attr("src").replace("ostatni", "ostatni2"));
});

$(".card-link.first").mouseover(function (e) {    
    $('.card-link.first #news').attr("src", $('.card-link.first #news').attr("src").replace("ostatni", "ostatni3"));
}).mouseout(function (e) {
    $('.card-link.first #news').attr("src", $('.card-link.first #news').attr("src").replace("ostatni3", "ostatni"));
});

// Modal close fix
$(function() {
    $(".modal button.close").appendTo('.modal');
});

// The news load more
$(function() {
    $("#load-news").click(function(e) { 
      e.preventDefault();
      $(".news-item:hidden").slice(0, 4).show();
      var val = $(".news-count-items strong").text().replace(/\+/g, ''); 
      var val2 = parseInt(val) - 4;
      var final = '+' + val2;
      $(".news-count-items strong").text(final);
      if ($(".news-item:hidden").length == 0) { 
        $(".news-count").remove(); 
      }
    });
});

/**
 * Improve "Accessibility" Owl.carousel
 */
 $(document).on('ready', function() {
    $( ".owl-dots" ).each(function() {
        $('.owl-dot').attr('aria-label', 'Navigace');
    });

    $( ".owl-nav" ).each(function() {
        $('.owl-prev').attr('title', 'Předchozí');
        $('.owl-next').attr('title', 'Další');
        $('.owl-prev').attr('aria-label', 'Předchozí');
        $('.owl-next').attr('aria-label', 'Další');
        $('.owl-prev, .owl-next').attr('data-toggle', 'tooltip');
    });

    $( ".owl-stage" ).each(function() {
        $('.owl-item img').attr('aria-label', 'Obrázek');
    });

    $( ".ez-toc-link" ).each(function( index ) {
        $(this).removeAttr('title');
    });
  
});
